export default {
  userInfo: {},
  userAddress: [],
  userCart: [],
  addressFrom: '', //从哪进入的收货地址页面,用于返回
  ifBindPhone: false
};
